import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BasisCounterLabelComponent } from './basis-counter-label.component';
import { MainTableService } from '../main-table.service';
import { map, switchMap } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ProductGroupsService } from '@prlw/core/products/product-groups.service';
import { MobileOverlayService } from '@prlw/libs/mobile-overlay/mobile-overlay.service';
import { MobileManageOverlayContainer } from '../../../mobile-manage-overlay/mobile-manage-overlay.container';
import { MainTableInstrumentsService } from '@prlw/core/monitor/main-table-instruments.service';
import { mapPending } from '@prlw/infrastructure/observableWithPending-v2';

@Component({
  selector: 'prlw-basis-counter-label',
  standalone: true,
  imports: [CommonModule, BasisCounterLabelComponent],
  templateUrl: './basis-counter-label.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasisCounterLabelContainer {
  constructor(
    private readonly mainTableService: MainTableService,
    private readonly mainTableInstrumentsService: MainTableInstrumentsService,
    private readonly productGroupsService: ProductGroupsService,
    private readonly mobileOverlayService: MobileOverlayService,
  ) {}

  currentProductGroup$ = this.productGroupsService.currentProductGroup$;
  preloaderActive$ =
    this.mainTableInstrumentsService.reqInstrumentsWithPending$.pipe(
      mapPending,
    );

  totalShipmentsForCurrentProductGroupCount$ =
    this.mainTableService.sortedInstruments$.pipe(
      switchMap(() =>
        this.mainTableService.sortedInstruments$.pipe(
          map(
            (items) =>
              Object.keys(
                items.reduce(
                  (acc, item) => ({
                    ...acc,
                    [item.shipment.code]: 1,
                  }),
                  {} as Record<string, unknown>,
                ),
              ).length,
          ),
        ),
      ),
    );

  handleOpenManageOverlay() {
    this.mobileOverlayService.show(MobileManageOverlayContainer);
  }
}
